import { render, staticRenderFns } from "./TitleRecommend.vue?vue&type=template&id=1bfebcc8&scoped=true&"
import script from "./TitleRecommend.vue?vue&type=script&lang=js&"
export * from "./TitleRecommend.vue?vue&type=script&lang=js&"
import style0 from "./TitleRecommend.vue?vue&type=style&index=0&id=1bfebcc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfebcc8",
  null
  
)

export default component.exports